import React from "react"
import types from "prop-types"
import ActivityCompletionIndicator from "./ActivityCompletionIndicator"

const TasksCompletedDataElement = ({ value, rowData }) => (
  <ActivityCompletionIndicator total={value} open={rowData.openTasksCount} label="completed" />
)

TasksCompletedDataElement.propTypes = {
  value: types.number.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  rowData: types.object.isRequired,
}

export default TasksCompletedDataElement
